import { useQuery } from 'react-query'

// Hooks
import { useIsExtension } from '../utility'
import { useAuthSettings } from '../authorization'

import { getQueryDefaults } from '../../helpers/api'

import { getAccess } from './requests'

export const useAccessQuery = () => {
  const authSettings = useAuthSettings()
  const isChromeExtension = useIsExtension()

  return useQuery('access', () => getAccess(authSettings), {
    ...getQueryDefaults(),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    enabled: Boolean(authSettings) && isChromeExtension,
  })
}
